/** @format */

import { post, get } from '@root/utils/httpWrap';

/**
 * 查询机构列表
 */
export interface IGetOrgDepListParam {
  orgDepId?: string[] | string | null; // 机构id
  orgDepCode?: string; // 机构编码
  currPage: string | number;
  pageSize: string | number;
}
export const getOrgDepList = (params?: IGetOrgDepListParam): Promise<ProjectListPageResponse<IOrgDep>> => {
  return post('/bangdao/saasapi/v1/system/orgDep/list', params);
};

/**
 * 新建机构
 */
export interface IOrgDep {
  parentId?: string; // 父机构id
  parentName?: string; // 父机构id
  orgDepId?: string; // 机构id
  orgDepName: string; // 机构名称
  orgDepCode: string; // 机构编码
  leader?: string; // 负责人
  phone?: string; // 联系电话
  address?: string; // 地址
}
export const addOrEditOrgDep = (params: IOrgDep): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/system/orgDep/addOrUpdate`, params);
};

/**
 * 删除机构
 */
export const deleteOrgDep = (params: { orgDepId: string }): Promise<ProjectResponse<any>> => {
  return post(`/bangdao/saasapi/v1/system/orgDep/delete`, params);
};

/**
 * 设置岗位组列表查询
 */
export const getSetPositions = (params: { orgDepId: string }): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/orgDep/getJobByOrgId', params);
};

/**
 * 设置岗位
 */
export interface ISetPostParam {
  orgDepId: string; // 机构id
  jobDefinitionsIdList: string[];
}
export const setPosition = (params: ISetPostParam): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/jobDefinitions/addPositions', params);
};

/**
 * 查询岗位组列表
 */
export interface IGetPositionGroupListParam {
  orgDepId?: string[] | string | null; // 机构id
  jobDefinitionsName?: string; // 岗位组名称
  currPage: string | number;
  pageSize: string | number;
}
export const getPositionGroupList = (params?: IGetPositionGroupListParam): Promise<ProjectListPageResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/jobDefinitions/list', params);
};

/**
 * 新增岗位组
 */
export interface IPositionGroup {
  jobDefinitionsId?: string; // 岗位组id
  orgDepId: string; // 机构id
  jobDefinitionsName: string; // 岗位组名称
  remark?: string; // 岗位组说明
  resourceIdList: string[]; // 权限
}
export const addOrEditPositionGroup = (params: IPositionGroup): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/jobDefinitions/addOrUpdate', params);
};

/**
 * 删除岗位组
 */
export const deletePositionGroup = (params: { jobDefinitionsId: string }): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/jobDefinitions/delete', params);
};

/**
 * 岗位组-获取众畅和一级机构下拉选项
 */
export const getOrgsFirstLevel = (): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/orgDep/selector');
};

/**
 * 用户 types
 */
export interface IGetUserListParam {
  orgDepId: string[] | string | null; // 机构id
  positionId: string[] | string | null; // 岗位id
  userName: string; // 账号
  realName: string; // 姓名
  currPage: string | number;
  pageSize: string | number;
}
export interface IUser {
  userId?: string;
  userName: string; // 登录账号
  realName: string; // 真实姓名
  password?: string; // 密码
  phone: string; // 手机号码
  orgDepId: string | string[] | null; // 机构id
  orgDepName?: string; // 机构名称
  status: string; // 账号状态 0 正常 1停用
  positionList: IPosition[]; // 岗位列表
  parkId: string | string[] | null; // 车场id
}
export interface IPosition {
  jobDefinitionsId: string;
  positionName: string;
  positionId: string;
}

/**
 * 查询用户列表
 */
export const getUserList = (params?: IGetUserListParam): Promise<ProjectListPageResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/user/list', params);
};

/**
 * 新增或更新用户
 */
export const addOrEditUser = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/user/addOrUpdate', params);
};

/**
 * 删除用户
 */
export const deleteUser = (params: { userId: string }): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/user/delete', params);
};

/**
 * 根据机构获取岗位下拉选项
 */
export const getPositionList = (params: { orgDepId: string }): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/orgDep/getPositionByOrgId', params);
};

/**
 * 根据机构获取岗位下拉选项
 */
export const resetPassword = (params: { userId: string; newPassword: string }): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/user/resetPassword', params);
};

/**
 * 获取用户Id
 */
export const getUserId = (params?: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/monitor/getUserId', params);
};
/**
 * 获取平台配置信息
 */
export const configureInfo = (): Promise<any> => {
  return get('/bangdao/saasapi/v1/configure/getInfo');
};
/**
 * 平台配置编辑
 */
export const configureEdit = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/configure/edit', params);
};
/**
 * 判断是否是同一个账户
 */
export const checkLogin = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/monitor/checkLogin', params);
};

/**
 * 查询用户
 */
export const querySdUserInfo = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/user/querySdUserInfo', params);
};
/**
 * 会员管理
 */
export const thirdUserviplist = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/thirdUser/list', params);
};
/**
 * 组织机构树
 */
export const listLeftTree = (params: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/system/orgDep/listLeftTree', params);
};
/**
 * 获取全屏链接设置详情
 */
export const getDataVConfig = (params?: any): Promise<ProjectResponse<any>> => {
  return post(`bangdao/saasapi/v1/monitor/getDataVConfig`, params);
};
/**
 * 全屏链接设置编辑 http://127.0.0.1:9106/bangdao/saasapi/v1/monitor/editDataVConfig
 */
export const editDataVConfig = (params?: any): Promise<ProjectResponse<any>> => {
  return post('/bangdao/saasapi/v1/monitor/editDataVConfig', params);
};
